import { useCallback, useEffect, useState } from 'react';

import { findPersona, PERSONAS, PersonaId } from './personas';

const STORAGE_KEY = 'kudable_persona_id';

const readStored = (): PersonaId | null => {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const match = PERSONAS.find((persona) => persona.id === raw);
  return match ? match.id : null;
};

export const usePersona = () => {
  const [personaId, setPersonaId] = useState<PersonaId | null>(() =>
    readStored(),
  );

  useEffect(() => {
    if (personaId) {
      window.localStorage.setItem(STORAGE_KEY, personaId);
    }
  }, [personaId]);

  const selectPersona = useCallback((id: PersonaId) => {
    setPersonaId(id);
  }, []);

  const clearPersona = useCallback(() => {
    window.localStorage.removeItem(STORAGE_KEY);
    setPersonaId(null);
  }, []);

  return {
    personaId,
    persona: findPersona(personaId),
    hasPicked: personaId !== null,
    selectPersona,
    clearPersona,
  };
};
